import styled from "styled-components";
import { ClientInfoBox, ClientLogoTile } from "./ClientNameBox";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const SecondaryText = styled.span`
  display: block;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #55544c;
  text-align: center;
`;

export interface ClientConsentContextProps {
  clientContextHeaderText: string;
  clientName?: string | undefined;
  clientContextText?: string | undefined;
  clientLogo?: string | undefined;
  isDesktop: boolean;
}

export default function ClientConsentContext(
  props: ClientConsentContextProps,
): JSX.Element {
  return (
    <Container data-testid="consent_context">
      <ClientInfoBox>
        {!!props.clientLogo && (
          <ClientLogoTile
            clientName={props.clientName ?? ""}
            clientLogo={props.clientLogo}
          />
        )}
        <div data-testid="client_name">{props.clientName}</div>
      </ClientInfoBox>
      {!!props.clientContextText && (
        <SecondaryText>{props.clientContextText}</SecondaryText>
      )}
    </Container>
  );
}
